import { assignNamespace } from "@gr-common/head/namespace-utils";
import { o_util } from "@gr-common/head/namespaces";
import { defineEvent } from "@gr-common/head/nexus";
import { isOnexGroup, mapOnexGroup, withOnex } from "./mappers.js";
import { fetchOnexData, readOnexData } from "./fragment.js";

export * from "./mappers.js";

assignNamespace(o_util, "onex", {
  isOnexGroup,
  mapOnexGroup,
  withOnex,
});

otto.onex.assignNamespace({
  assignments: defineEvent(),
});

readOnexData();
fetchOnexData();
